'use client'
import { Global } from '@emotion/react'

const Fonts = () => (
  <Global
    styles={`
            /* Lausanne 300 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 300;
                src:
                url(/fonts/lausanne/Lausanne-300.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-300.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 300;
                src:
                url(/fonts/lausanne/Lausanne-300Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-300Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* Lausanne 400 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 400;
                src:
                url(/fonts/lausanne/Lausanne-400.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-400.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 400;
                src:
                url(/fonts/lausanne/Lausanne-400Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-400Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* Lausanne 500 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 500;
                src:
                url(/fonts/lausanne/Lausanne-500.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-500.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 500;
                src:
                url(/fonts/lausanne/Lausanne-500Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-500Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* Lausanne 600 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 600;
                src:
                url(/fonts/lausanne/Lausanne-600.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-600.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 600;
                src:
                url(/fonts/lausanne/Lausanne-600Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-600Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* Lausanne 700 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 700;
                src:
                url(/fonts/lausanne/Lausanne-700.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-700.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 700;
                src:
                url(/fonts/lausanne/Lausanne-700Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-700Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* Lausanne 800 */
            @font-face {
                font-family: 'Lausanne';
                font-style: normal;
                font-weight: 800;
                src:
                url(/fonts/lausanne/Lausanne-800.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-800.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Lausanne';
                font-style: italic;
                font-weight: 800;
                src:
                url(/fonts/lausanne/Lausanne-800Italic.woff2) format('woff2'),
                url(/fonts/lausanne/Lausanne-800Italic.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* CooperBTStdLight */
            @font-face {
                font-family: "Cooper";
                font-style: normal;
                font-weight: 400;
                src:
                url(/fonts/cooper/CooperBTStdLight.woff2) format('woff2'),
                url(/fonts/cooper/CooperBTStdLight.woff) format('woff');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
                U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
                U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }
      `}
  />
)

export default Fonts
